import { TagBlocked } from "../../../../types/global.types";
import "./blockedTag.scss";

interface Props {
  tagBlocked: TagBlocked;
}

const BlockedTag = ({ tagBlocked }: Props) => {
  return (
    <div className="blocked-tag">
      <div className="blocked-tag-wrapper">
        <div className="blocked-short-message">
          <div className="blocked-short-message-text">
            <svg
              width="23"
              height="26"
              viewBox="0 0 23 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.625 10.6533H5.4875C3.3543 10.6533 1.625 12.3826 1.625 14.5158V20.5408C1.625 22.674 3.3543 24.4033 5.4875 24.4033H17.7625C19.8957 24.4033 21.625 22.674 21.625 20.5408V14.5158C21.625 12.3826 19.8957 10.6533 17.7625 10.6533H16.625M6.625 10.6533V6.90332C6.625 4.1419 8.86358 1.90332 11.625 1.90332V1.90332C14.3864 1.90332 16.625 4.1419 16.625 6.90332V10.6533M6.625 10.6533H16.625M11.625 15.6533V19.4033"
                stroke="white"
                strokeWidth="2.3175"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            {tagBlocked.shortBlockedMessage}
          </div>
        </div>

        {tagBlocked.isAmountRule && (
          <div className="blocked-bar">
            <div
              className="blocked-bar-filled"
              style={{ width: `${tagBlocked.differencePercent}%` }}
            ></div>
            <div className="blocked-bar-empty"></div>
          </div>
        )}

        <div className="blocked-long-message-wrapper">
          <div className="blocked-long-message">
            {tagBlocked.longBlockMessage}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockedTag;
